import { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Heading, Pane } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import { getEventReservation, getEvents, getPaymentTypes, updateEventReservation } from '../actions/EventReservationActions';
import EventReservationForm from '../components/EventReservationForm';

import { Link } from 'react-router-dom';

import Configuration from '../Config';

const validation = Configuration.Validations;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditEventReservation extends Component {
    constructor(props) {
        super(props);
        this.id = this.props.params.id;
    }

    componentDidMount() {
        this.props.dispatch(getEventReservation(this.id));
        // Only load payment types, events will be searched on demand
        this.props.dispatch(getPaymentTypes());
    }

    handleSave = (values) => {
        this.props.dispatch(updateEventReservation(this.props.reservation.id, values));
    }

    render() {
        const { reservation } = this.props;
        
        // Ensure amount is set to event price
        const initialValues = {
            ...reservation,
            amount: reservation.event?.price || reservation.amount || 0
        };
        
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex" gap={16}>
                    <Pane>
                        <Link to="/event-reservations">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista rezervari
                            </Button>
                        </Link>
                    </Pane>

                    <Pane>
                        <Link to={`/event-reservations/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Rezervare - <strong>{this.props.reservation.confirmationCode}</strong>
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <EventReservationForm
                            isEdit={true}
                            initialValues={initialValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            events={this.props.events}
                            paymentTypes={this.props.paymentTypes}
                            errors={this.props.errors} />
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.eventReservations.errors.type === 'validation' ? mapValidationErrors(state.eventReservations.errors.fields) : [],
        reservation: state.eventReservations.current,
        events: state.eventReservations.events || [],
        paymentTypes: state.eventReservations.paymentTypes || []
    }
}

export default connect(mapStateToProps)(EditEventReservation);
